// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { ClientsState } from '../_reducers/client.reducers';
import { Client } from '../_models/client.model';

export const selectClientsState = createFeatureSelector<ClientsState>('client');

export const selectClientById = (clientId: number) =>
  createSelector(selectClientsState, (clientsState) => clientsState.entities[clientId]);

export const selectClientsPageLoading = createSelector(selectClientsState, (clientsState) => {
  return clientsState.listLoading;
});

export const selectClientsActionLoading = createSelector(
  selectClientsState,
  (clientsState) => clientsState.actionsloading,
);

export const selectLastCreatedClientId = createSelector(
  selectClientsState,
  (clientsState) => clientsState.lastCreatedClientId,
);

export const selectClientsPageLastQuery = createSelector(
  selectClientsState,
  (clientsState) => clientsState.lastQuery,
);
export const selectClientError = createSelector(
  selectClientsState,
  (clientsState) => clientsState.error,
);
export const selectClientLatestSuccessfullAction = createSelector(
  selectClientsState,
  (clientsState) => clientsState.latestSuccessfullAction,
);
export const selectClientsInStore = createSelector(selectClientsState, (clientsState) => {
  const items = (clientsState.ids as number[])
    .map((id) => clientsState.entities[id])
    .filter((item): item is Client => item !== undefined);
  return new QueryResultsModel(items, clientsState.totalCount);
});

export const selectClientsShowInitWaitingMessage = createSelector(
  selectClientsState,
  (clientsState) => clientsState.showInitWaitingMessage,
);

export const selectHasClientsInStore = createSelector(selectClientsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
